var map = {
	"./banner/HomePage-IT.webp": 961,
	"./banner/HomePage-agencies.webp": 962,
	"./banner/HomePage-banks.webp": 963,
	"./banner/HomePage-elearning.webp": 964,
	"./banner/HomePage-foods.webp": 965,
	"./banner/HomePage-industries.webp": 966,
	"./banner/HomePage-innovation.webp": 967,
	"./banner/HomePage-insurance.webp": 968,
	"./banner/HomePage-manufacturing-firms.webp": 969,
	"./banner/HomePage-media.webp": 970,
	"./banner/HomePage-universities.webp": 971,
	"./banner/Khandevane.png": 972,
	"./banner/sunich.png": 973
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 863;